'use client';

import { useCallback, useSyncExternalStore } from 'react';

const YEAR_CHECK_INTERVAL = 60 * 60 * 1000;

function subscribe(onStoreChange: () => void) {
    const interval = window.setInterval(onStoreChange, YEAR_CHECK_INTERVAL);
    window.addEventListener('focus', onStoreChange);

    return () => {
        window.clearInterval(interval);
        window.removeEventListener('focus', onStoreChange);
    };
}

function formatYear(locale: string, timeZone: string) {
    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        timeZone,
    }).format(new Date());
}

export default function DynamicCopyright({
    template,
    locale,
    timeZone,
    serverYear,
}: {
    template: string;
    locale: string;
    timeZone: string;
    serverYear: string;
}) {
    const getSnapshot = useCallback(() => formatYear(locale, timeZone), [locale, timeZone]);
    const getServerSnapshot = useCallback(() => serverYear, [serverYear]);
    const year = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

    return template.replace(/\{year\}/g, year);
}
